import React from 'react';
import { Grid } from '@mui/material';
import { Nullable } from '@jamesgmarks/utilities';
import { SubscriptionNotesEditor } from '../../EditorComponents/NotesEditor/SubscriptionNotesEditor';
import { FileUploader } from '../../EditorComponents/FileUpload/FileUploader';
import { TJsonNoteWithFlag } from '../types';

interface ISubscriptionAdditionalInfoProps {
  subscriptionNotes: TJsonNoteWithFlag[];
  userId: Nullable<number>;
  onDeleteNote: (index: number) => void;
  onAddNote: (noteText: string) => void;
  setUploadedFile: React.Dispatch<React.SetStateAction<Nullable<File>>>;
  requiresNote?: boolean;
  hasChanges?: boolean;
  changedFields?: string[];
}

export const SubscriptionAdditionalInfo: React.FC<ISubscriptionAdditionalInfoProps> = ({
  subscriptionNotes,
  userId,
  onDeleteNote,
  onAddNote,
  setUploadedFile,
  requiresNote = false,
  hasChanges = false,
  changedFields = [],
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <SubscriptionNotesEditor
          notes={subscriptionNotes}
          currentUserId={userId ?? 0}
          onDelete={onDeleteNote}
          onAdd={onAddNote}
          requiresNote={requiresNote}
          hasChanges={hasChanges}
          changedFields={changedFields}
        />
      </Grid>

      {/* <Grid item xs={12}>
        <FileUploader onFileUpload={(file) => setUploadedFile(file)} />
      </Grid> */}
    </Grid>
  );
};
